import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { UrlApi, authorization } from '../../../UrlApi/UrlApi';
import axios from 'axios';
import { AlertError } from '../../../Components/AlertDialog/AlertDialog';
import moment from 'moment';
import { ButtonOther } from '../../../Components/Button/Button';
import RefreshIcon from "@mui/icons-material/Refresh";
import { DatePicker } from '@mui/x-date-pickers';
import * as SiIcons from "react-icons/si";
import ExportExcel from '../../../Components/ExportExcel/ExportExcel';
import { Card } from '@mui/material';
import DataTable from '../../../Components/DataTable/DataTable';
import Loading from "../../../Components/Loading/Loading";
import DateRange from '../../../Components/DateRange/DateRange';

function ReportChangePassword() {
    const [masterData, setMasterData] = useState([]);
    const [pageSize, setPageSize] = useState(50);
    const [variable, setVariable] = useState({
        startDate: new Date(),
        endDate: new Date(),
    });

    async function getChangePassword(start_date, end_date) {
        const url =
            UrlApi +
            `report_change_password?start_date=${moment(start_date).format("YYYY-MM-DD")}&end_date=${moment(end_date).format("YYYY-MM-DD")}`;
        await axios
            .get(url, authorization)
            .then((res) => {
                res.data.map((e, idx) => {
                    e.list_no = idx + 1
                    e.savetime = moment(e.savetime).format("DD/MM/YYYY")
                })
                setMasterData(res.data);
            })
            .catch((err) => {
                AlertError(err);
            });
    }

    const columns = [
        {
            title: "ลำดับ",
            field: "list_no",
            filtering: false,
            headerStyle: {
                width: "3rem",
                maxWidth: "3rem",
              },
              cellStyle: { width: "3rem", maxWidth: "3rem" },
        },
        {
            title: "รหัสพนักงาน",
            field: "emp_code",
            height: 10,
            headerStyle: {
                width: "5%",
                maxWidth: "5%",
              },
              cellStyle: { width: "5%", maxWidth: "5%" },
        },
        {
            title: "ชื่อพนักงาน",
            field: "fullname",
            height: 10,
            headerStyle: {
                width: "5%",
                maxWidth: "5%",
              },
              cellStyle: { width: "5%", maxWidth: "5%" },
        },
        {
            title: "วันที่เปลี่ยนรหัสผ่าน",
            field: "savetime",
            height: 10,
            width: "10rem",
        },
    ];

    
    function datePicker() {
        return (
            <>
                <DateRange
                    onClick={(date) => {
                        variable.startDate = date[0].startDate;
                        variable.endDate = date[0].endDate;
                        getChangePassword(date[0].startDate, date[0].endDate);
                    }}
                />
            </>
        );
    }

    const exportExcells = () => {
        let columnExport = [];
        columns.map((item) => {
            if (item.title !== "เปิด") {
                columnExport.push(item.title);
            }
        });

        const header = [
            "",
            "รายงานประจำวันที่ " +
            moment(variable.startDate).format("DD/MM/YYYY") +
            " ถึง " +
            moment(variable.endDate).format("DD/MM/YYYY"),
        ];
        const data = masterData.map((item) => {
            return [
                item.list_no,
                item.emp_code,
                item.fullname,
                item.savetime
            ];
        });
        ExportExcel(
            data,
            columnExport,
            'รายงานประวัติการเปลี่ยนรหัสผ่าน',
            "รายงานประวัติการเปลี่ยนรหัสผ่าน.xlsx",
            header,
        );
    };

    const HeaderPage = () => {
        return (
            <>
                <div style={{ paddingTop: "10px" }}>
                    <label
                        style={{ marginLeft: "10px", marginTop: "10px", fontSize: "18px" }}
                    >
                        รายงานประวัติการเปลี่ยนรหัสผ่าน
                    </label>
                    <div
                        style={{
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                            }}
                        >
                            {datePicker()}
                            <div style={{ marginLeft: '38px' }}>
                                <ButtonOther
                                    onClick={() => {
                                        getChangePassword(variable.startDate, variable.endDate);
                                    }}
                                    message="โหลดข้อมูลใหม่"
                                    width="20ch"
                                    startIcon={<RefreshIcon />}
                                    background="#61C495"
                                />
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                            }}
                        >
                            <div style={{ marginRight: "12px", marginTop: "2px" }}>
                            </div>
                            {
                                <ButtonOther
                                    onClick={() => {
                                        exportExcells();
                                    }}
                                    message="ส่งออก"
                                    width="15ch"
                                    startIcon={<SiIcons.SiMicrosoftexcel />}

                                />
                            }
                        </div>
                    </div>
                </div>
            </>
        );
    };
  return (
    <>
    <Card
        variant="outlined"
        style={{
            paddingLeft: "10px",
            paddingRight: "10px",
            borderRadius: "10px",
        }}
    >
        {HeaderPage()}
        <DataTable
            exportButton={false}
            columns={columns}
            data={masterData}
            width="100%"
            countRowData={masterData.length}
            pageSize={pageSize}
            options={{
                headerStyle: {
                    textAlign: 'center',
                },
                cellStyle: {
                    textAlign: 'left',
                },
            }}
        />
    </Card>
    <Loading open={variable.loading} />
</>
  )
}

export default ReportChangePassword